function locationOf<T>(element: T, dataset: T[], key: string, inputStart?: number, inputEnd?: number) {
  const start = inputStart || 0;
  const end = inputEnd || dataset.length;
  const pivot = parseInt((start + (end - start) / 2).toString(), 10);
  // @ts-ignore
  if (end - start <= 1 || dataset[pivot][key] === element[key]) {
    return pivot;
  }
  // @ts-ignore
  if (dataset[pivot][key] < element[key]) {
    return locationOf(element, dataset, key, pivot, end);
  }

  return locationOf(element, dataset, key, start, pivot);
}

/**
  Add an element to an array in sorted position
  @param  element  Element to be inserted
  @param  dataset  Sorted array of elements to be inserted into
  @param  key      The key in the JSON element to filter on
  @returns  Dataset with element inserted in proper locaiton
*/
function sortedInsert<T>(element: T, dataset: T[], key: string) {
  dataset.splice(locationOf<T>(element, dataset, key) + 1, 0, element);
  return dataset;
}

type FilterObjectsParams<T> = {
  lhs: T[];
  rhs: T[];
  key: keyof T;
};
function filterObjectsOutOfLhs<T extends Record<string, any>>({
  lhs,
  rhs,
  key,
}: FilterObjectsParams<T>): T[] {
  // Build a Set of all keys in rhs for O(1) lookups
  const rhsIds = new Set(rhs.map(item => item[key]));
  // Keep only those lhs objects whose key is NOT in rhs
  return lhs.filter(item => !rhsIds.has(item[key]));
}

const DataModifier = {
  sortedInsert,
  filterObjectsOutOfLhs,
};
export default DataModifier;
